<template>
  <div>
    <div
      v-if="!clicked"
      class="bg-sand whitespace-pre-wrap rounded-full px-5 py-2.5 text-xs font-semibold lg:text-lg"
      @click="clicked = !clicked"
    >
      {{ question.title }}
    </div>
    <TransitionsFadeUp v-else>
      <div
        class="bottom-22 bg-blue-lighter static w-full rounded-3xl px-5 py-2.5 transition-all"
        @click="clicked = !clicked"
      >
        <span class="whitespace-pre-wrap text-xs font-semibold lg:text-lg">{{ question.title }}</span>
        <br><br>
        <SofieText
          class="prose !text-black"
          :value="question.answer"
        />
        <br>
        <NuxtLink
          v-if="question.url"
          :to="question.url"
          class="text-white"
        >
          {{ $t('Read more') }}
        </NuxtLink>
      </div>
    </TransitionsFadeUp>
  </div>
</template>

<script lang="ts" setup>
import type {Vraag} from '~/graphql/graphql';

defineProps<{
  question: Vraag
}>();

const clicked = ref(false);
</script>
